import { reactive, computed } from 'vue';

export function useForm(initialValues, validationRules) {
  const values = reactive({ ...initialValues });
  const errors = reactive({});
  const touched = reactive({});

  Object.keys(initialValues).forEach((key) => {
    errors[key] = '';
    touched[key] = false;
  });

  function validateField(field) {
    const value = (values[field] + '').trim();
    const rule = validationRules[field];
    errors[field] = rule ? rule(value, values) : '';
  }

  function onBlur(field) {
    touched[field] = true;
    validateField(field);
  }

  function onInput(field) {
    if (touched[field]) validateField(field);
  }

  const isValid = computed(() => {
    Object.keys(validationRules).forEach((f) => validateField(f));
    return Object.values(errors).every((err) => !err);
  });

  return {
    values,
    errors,
    touched,
    onBlur,
    onInput,
    isValid,
  };
}
